import { createSlice as p } from "@reduxjs/toolkit";
import { U as t } from "./cmsTransformer-239cfecd.mjs";
import { o as r } from "./ContactType-9a05b343.mjs";
const d = {
  mailingAddress: {
    contactType: r.Mailing
  },
  billingAddress: {
    contactType: r.Billing
  },
  taxAddress: {
    contactType: r.Tax
  },
  useAsBilling: !0,
  useAsMailing: !0,
  profileData: {
    firstName: "",
    lastName: "",
    titleSalutation: "",
    gender: "",
    maritalStatus: "",
    birthDate: "",
    citizenship: "",
    idNumber: ""
  },
  profileContacts: {
    email: "",
    phone: "",
    dialCode: "",
    alternativePhone: []
  }
}, n = {
  title: "",
  description: ""
}, s = {
  contactInformation: {
    firstName: "",
    lastName: "",
    email: ""
  },
  downlineAddressDetails: {
    downLinerOwnerId: ""
  },
  registrationFlowData: {
    flowName: "",
    currentStepName: "",
    isSelfInitiatedFlowV2: !1,
    currentIndex: -1,
    findOutMoreUrl: "",
    redirectUrl: "",
    isDuplicateUser: !1,
    isChangeUsernameModalOpen: !1,
    isErrorModalOpen: !1,
    isRedirectedFromModal: !1,
    openOtpDrawer: !1,
    isIDVerified: !1,
    clearUserIdImage: !1,
    selectAccountType: {
      accountTypes: []
    },
    userData: {
      // To decide remain the data in 'userData' or move to root of registrationFlowData
      jwtToken: "",
      registrationId: "",
      patchVersion: 1,
      // This required for PATCH /registrations use for incremental version tracking
      profileId: ""
    },
    OtpData: {
      challengeId: "",
      isOTPVerified: !1,
      inputType: ""
    },
    signupFormData: {
      firstName: "",
      lastName: "",
      userName: "",
      usernameType: "",
      dialCode: "",
      tncCheckbox: !1,
      useCheckbox: !1,
      privacyCheckbox: !1,
      aboAccountId: "",
      modValue: "",
      generateOtp: !1
    },
    selectSponsor: {
      sponsor: {},
      knowABO: !0,
      sponsorSearchText: "",
      isInternational: !1,
      internationalSponsor: {},
      internationalSponsorCountryCode: "",
      internationalSponsorTncCheckbox: !1,
      internationalSposnorVerified: !1,
      editSponsor: !0,
      setInternationalSponsor: !1,
      hideSponsorRadioSelection: !1
    },
    initialRegistrationForm: {
      inputForm: {
        idNumber: "",
        firstName: "",
        lastName: "",
        privacyPolicy: !1,
        tncCheckbox: !1,
        createPassword: "",
        userName: ""
      }
    },
    perosonalDetails: {
      isFieldDisabled: !0,
      dialCode: "+66",
      isAddressSearchFocused: !1,
      assignAboCheckbox: !1,
      firstName: "",
      lastName: "",
      userName: "",
      createPassword: "",
      // it contains valid and invalid value, required for identity component
      password: "",
      // it will filled only when password is valid
      birthDate: "",
      gender: "",
      secondaryContact: "",
      taxRegime: "",
      citizenshipCountry: "",
      personalIdType: "",
      personalIdRecordNumber: "",
      termsAndConditionCheckbox: !1,
      email: "",
      phone: "",
      personalIdDocument: void 0,
      billingAddress: !1,
      sponsor: ""
    },
    coAppPersonalDetails: {
      isFieldDisabled: !0,
      dialCode: "+66",
      isAddressSearchFocused: !1,
      assignAboCheckbox: !1,
      firstName: "",
      lastName: "",
      userName: "",
      createPassword: "",
      // it contains valid and invalid value, required for identity component
      password: "",
      // it will filled only when password is valid
      birthDate: "",
      gender: "",
      secondaryContact: "",
      taxRegime: "",
      citizenshipCountry: "",
      personalIdType: "",
      personalIdRecordNumber: "",
      termsAndConditionCheckbox: !1,
      email: "",
      phone: "",
      personalIdDocument: void 0,
      billingAddress: !1,
      sponsor: ""
    },
    documentDataList: [],
    cidVerification: {
      isUserCidVerified: !1,
      isSpouseVerified: !1,
      isRadioChanged: !1,
      recordType: "",
      verifyUser: !1,
      isUser: !1,
      isSpouse: !1,
      spouseRecordType: ""
    },
    aboKitVerified: !1
  },
  registrationCmsData: {
    title: "",
    signUpCustomer: {
      customerImage: t,
      ABOImage: t
    },
    profileComplete: {
      image: t,
      title: "",
      desc: "",
      subTitle: ""
    },
    selectSponsor: {
      internationalSponsorTnc1: "",
      internationalSponsorTnc2: ""
    },
    noRecordImage: t,
    googleIcon: t,
    facebookIcon: t,
    passportLoading: t,
    personalDetailsDesktopImage: t,
    sampleCid: t,
    samplePassport: t,
    cidLoading: t,
    accountCardImage: t,
    accountUpgradeImage: t,
    coApp: {
      landingImage: t,
      pendingImage: t,
      completedImage: t,
      registrationImage: t,
      marriageCertImage: t,
      tnc: ""
    }
  },
  profileInformation: { ...d },
  tasksInformation: {
    taskCompleted: !0,
    tasks: []
  },
  accountInformation: { ...d },
  accountTypeImagesCMS: {},
  termsNConditionsCMS: {},
  accountLifeCycleCmsData: {
    title: "",
    autoRenewalTermsCondition: n,
    downgradeTermsCondition: n,
    upgradeTermsCondition: n,
    renewalTermsCondition: n,
    downgradeModalPrivileges: "",
    eKitTermsCondition: n,
    renewalCardImage: t,
    upgradeDesktopImage: t,
    upgradeScreenImage: t
  },
  accountAutoRenewalData: {
    autoRenewEnabled: !1,
    registrationId: "",
    selectedKitSku: "",
    selectedFeeSku: "",
    changeKitSku: !1,
    totalAmount: 0,
    currency: "",
    qty: 1,
    paymentTransactionData: [],
    paymentId: "",
    checkoutProfile: null,
    agreeTnC: !1
  },
  apiErrorData: { message: "" },
  registrationOrderConfirmationImagesCMSData: [],
  currentFlowSteps: []
}, l = p({
  name: "commerceProfile",
  initialState: s,
  reducers: {
    addContactInformation: (a, e) => (a.contactInformation = e.payload, a),
    updateCustomerType: (a, e) => (a.selectedAccountType = e.payload, a),
    updateDownlineDetails: (a, e) => (a.downlineAddressDetails = e.payload, a),
    updateRegistrationData: (a, e) => (a.registrationFlowData = {
      ...a.registrationFlowData,
      ...e.payload
    }, a),
    updateCoAppPersonalData: (a, e) => (a.registrationFlowData.coAppPersonalDetails = {
      ...a.registrationFlowData.coAppPersonalDetails,
      ...e.payload
    }, a),
    updateResetCoAppPersonalData: (a) => (a.registrationFlowData.coAppPersonalDetails = s.registrationFlowData.coAppPersonalDetails, a),
    updateRegistrationCmsData: (a, e) => (a.registrationCmsData = {
      ...a.registrationCmsData,
      ...e.payload
    }, a),
    updateProfileInformationData: (a, e) => (a.profileInformation = {
      ...a.profileInformation,
      ...e.payload
    }, a),
    updateTasksInformationData: (a, e) => (a.tasksInformation = { ...a.tasksInformation, ...e.payload }, a),
    updateAccountInformation: (a, e) => (a.accountInformation = {
      ...a.accountInformation,
      ...e.payload
    }, a),
    updateAccountTypeImagesCMS: (a, e) => {
      const { type: o, data: i } = e.payload;
      return a.accountTypeImagesCMS[o] = { ...a.accountTypeImagesCMS[o], ...i }, a;
    },
    updateTermsNConditionsCMS: (a, e) => {
      const { type: o, data: i } = e.payload;
      return a.termsNConditionsCMS[o] = { ...a.termsNConditionsCMS[o], ...i }, a;
    },
    updateAccountLifeCycleCmsData: (a, e) => (a.accountLifeCycleCmsData = {
      ...a.accountLifeCycleCmsData,
      ...e.payload
    }, a),
    updateApiErrorData: (a, e) => (a.apiErrorData = {
      ...e.payload
    }, a),
    updateAccountAutoRenewalData: (a, e) => (a.accountAutoRenewalData = { ...a.accountAutoRenewalData, ...e.payload }, a),
    updateRegistrationOrderConfirmationImagesCMSData: (a, e) => (a.registrationOrderConfirmationImagesCMSData = e.payload, a),
    updateCurrentFlowStepsData: (a, e) => (a.currentFlowSteps = e.payload, a),
    resetRegistrationState: () => s
  },
  extraReducers: () => {
  }
}), {
  addContactInformation: g,
  updateCustomerType: C,
  updateDownlineDetails: D,
  updateRegistrationData: I,
  updateCoAppPersonalData: f,
  updateResetCoAppPersonalData: y,
  updateRegistrationCmsData: S,
  updateProfileInformationData: A,
  updateTasksInformationData: w,
  updateAccountInformation: T,
  updateAccountLifeCycleCmsData: h,
  updateAccountTypeImagesCMS: b,
  updateTermsNConditionsCMS: R,
  updateAccountAutoRenewalData: N,
  updateApiErrorData: k,
  updateRegistrationOrderConfirmationImagesCMSData: F,
  updateCurrentFlowStepsData: M,
  resetRegistrationState: P
} = l.actions;
export {
  A,
  C,
  I as D,
  P as F,
  f as I,
  F as M,
  R as N,
  M as P,
  N as R,
  S,
  w as T,
  b,
  g as f,
  D as g,
  h,
  k,
  l as p,
  T as w,
  y
};
//# sourceMappingURL=profileSlice-e9aaa6da.mjs.map
